import axios from 'axios';


axios.interceptors.response.use(null, error => {
    if(error.response?.status === 419) {
        alert('Votre session a expiré, veuillez appuyer sur Ok pour recharger la page');
        location.reload();
    }
    return Promise.reject(error);
});


const api = axios.create({
    baseURL: '/api',
});


export function getInterviews({ group }) {
    return api.get(`/interviews`, {
        params: {
            group
        }
    }).then(response => response.data.data);
}

export function getInterview(interviewId) {
    return api.get(`/interviews/${interviewId}`)
        .then(response => response.data.data);
}

export function getLexiconWord(wordId) {
    return api.get(`/lexicon/words/${wordId}`)
        .then(response => response.data.data);
}

export function getBreadcrumbPages(pageId) {
    return api.get(`/breadcrumb/pages/${pageId}`)
        .then(response => response.data.data);
}
